import { Component, input, output } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import {
  DroitsInterventions,
  NatureIntervention,
  UtilisateurIntervention,
} from '../../Services/intervention-edition';

/** Menu de présentation : émet un choix de création, sans charger de données ni ouvrir la modale. */
@Component({
  selector: 'app-intervention-actions',
  imports: [MatMenuModule, MatTooltipModule, RouterLink],
  template: `
    @if (utilisateur()) {
      <button
        type="button"
        class="interventions-trigger"
        [matMenuTriggerFor]="actions"
        [attr.aria-label]="libelle()"
        [matTooltip]="infobulle()"
        [matTooltipDisabled]="!infobulle()"
        matTooltipPosition="below"
        [disabled]="indisponible()"
        (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()"
      >
        <span class="material-symbols-outlined" aria-hidden="true">construction</span>
        @if (afficherLibelle()) {
          <span>{{ texteBouton() }}</span>
        }
        @if (compteur() !== null) {
          <span class="compteur">{{ compteur() }}</span>
        }
      </button>
      <!-- La planification dépend des droits ; le bon est proposé à tout utilisateur connecté. -->
      <mat-menu #actions="matMenu" class="intervention-actions-menu">
        @if (droits().planifier) {
          <button mat-menu-item type="button" (click)="choisir.emit('planification')">
            <span class="action-contenu">
              <span class="material-symbols-outlined action-icone" aria-hidden="true">event</span>
              <span class="action-texte">
                <span class="action-titre">Planifier une intervention</span>
                <span class="action-description"
                  >Prévoir une intervention à venir : date, horaires et travail à réaliser.</span
                >
              </span>
            </span>
          </button>
        }
        <button mat-menu-item type="button" (click)="choisir.emit('bon')">
          <span class="action-contenu">
            <span class="material-symbols-outlined action-icone" aria-hidden="true"
              >assignment_turned_in</span
            >
            <span class="action-texte">
              <span class="action-titre">Créer un bon d’intervention</span>
              <span class="action-description"
                >Rendre compte d’une intervention réalisée : travaux, photos et résolution du
                problème.</span
              >
            </span>
          </span>
        </button>
        @if (calendrier()) {
          <a mat-menu-item routerLink="/maintenance" class="action-calendrier">
            <span class="action-contenu">
              <span class="material-symbols-outlined" aria-hidden="true">calendar_month</span>
              <span>Voir le calendrier</span>
            </span>
          </a>
        }
      </mat-menu>
    }
  `,
  styles: `
    .action-contenu {
      display: flex;
      align-items: flex-start;
      gap: 12px;
      padding: 12px 0;
    }
    .action-icone {
      flex: 0 0 36px;
      width: 36px;
      height: 36px;
      display: grid;
      place-items: center;
      border-radius: 10px;
      background: var(--sidebar-light);
      color: var(--green-deep);
      font-size: 22px;
    }
    .action-texte {
      display: grid;
      gap: 4px;
      min-width: 0;
      white-space: normal;
    }
    .action-titre {
      font-size: 14px;
      font-weight: 700;
      line-height: 1.5;
      color: var(--text);
    }
    .action-description {
      font-size: 13px;
      line-height: 1.5;
      color: #555e57;
    }
    .action-calendrier {
      border-top: 1px solid var(--line);
      color: var(--green-deep);
    }
    .action-calendrier .action-contenu {
      align-items: center;
      padding: 4px 0;
    }
    /* Les variables permettent aux points d’entrée d’adapter le bouton à leur conteneur. */
    .interventions-trigger {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      min-height: 40px;
      min-width: 40px;
      padding: var(--interventions-trigger-padding, 8px 12px);
      border: var(--interventions-trigger-border, 0);
      border-radius: var(--interventions-trigger-radius, 12px);
      background: var(--interventions-trigger-background, #096b59);
      color: var(--interventions-trigger-color, white);
      font: var(--interventions-trigger-font, inherit);
      cursor: pointer;
    }
    .interventions-trigger .material-symbols-outlined {
      font-size: var(--interventions-trigger-icon-size, 24px);
    }
    .interventions-trigger:hover {
      filter: brightness(0.96);
    }
    .interventions-trigger:focus-visible {
      outline: 3px solid #15334b;
      outline-offset: 3px;
    }
    .interventions-trigger:disabled {
      opacity: 0.6;
      cursor: default;
    }
    .compteur {
      border-radius: 20px;
      padding: 2px 8px;
      background: #0f6d58;
      color: #fff;
    }
  `,
})
export class InterventionActions {
  readonly utilisateur = input.required<UtilisateurIntervention | null>();
  readonly droits = input.required<DroitsInterventions>();
  readonly libelle = input('Actions sur les interventions');
  readonly texteBouton = input('Interventions');
  readonly infobulle = input('');
  readonly afficherLibelle = input(false);
  readonly indisponible = input(false);
  readonly calendrier = input(false);
  readonly compteur = input<number | null>(null);
  /** Le composant parent applique les contrôles d’accès avant d’ouvrir le formulaire demandé. */
  readonly choisir = output<NatureIntervention>();
}
